import { connect } from 'react-redux';
import { compose } from 'redux';
import { GraphQLStateHandlerFactory } from '@twigeducation/graphql-state-handler';
import { graphql } from '@apollo/client/react/hoc';
import Marketingsites from './Marketingsites';
import { marketingSiteQuery, params } from './Marketingsites.query';
import { addMarketingsites } from '../../store/actions/marketingsites';
import withMarketingSites from './withMarketingSites';

const mapStateToProps = state => ({
    tocsApp: state.subscriptions.tocsApp,
});

const mapDispatchToProps = dispatch => ({
    addMarketingsites: sites => dispatch(addMarketingsites(sites)),
});
const enhance = compose(
    connect(mapStateToProps, mapDispatchToProps),
    graphql(marketingSiteQuery, params),
    GraphQLStateHandlerFactory('data', true),
    withMarketingSites,
);

export default enhance(Marketingsites);
